export default __webpack_public_path__ + "static/media/bioprocess-solution.5768302b.png";